// extracted by mini-css-extract-plugin
module.exports = {"root":"Breadcrumbs_root__XIfEz","text":"Breadcrumbs_text__ySkAa","active":"Breadcrumbs_active__nX8wR"};